// Form24.jsx
import React from "react";
import moment from "moment";
import { getStateFromVehicleNumber } from "../../Utils/helpers";

/** Small helpers */
const safe = (v, fallback = "") =>
  v === null || v === undefined || v === "" ? fallback : v;

const dmy = (v) => (v ? moment(new Date(v)).format("DD-MMM-YYYY") : "");

export default function Form24({ rcData }) {
  const v = rcData?.vehicle_data || {};
  const owner = rcData?.owner_data || {};
  const pucc = rcData?.pucc_data || {};
  const ins = rcData?.insurance_data || {};
  const permit = rcData?.permit_data || {};
  const npermit = rcData?.national_permit_data || {};

  return (
    <div id="rc-card" className="w-[900px] bg-white text-[13px] text-gray-900">
      {/* Page container (A4-friendly) */}
      <div className="mx-auto max-w-[900px] p-6">
        {/* Title */}
        <div className="text-center">
          <h1 className="text-[12px] font-semibold tracking-wide">
            <span className="border-b border-black">
              <span className="relative -top-2">
                FORM 24 (MOTOR VEHICLE REGISTER)
              </span>
            </span>
          </h1>
          <h1 className="mt-1 text-[12px] font-semibold tracking-wide">
            <span className="border-b border-black">
              <span className="relative -top-2">{`${String(
                getStateFromVehicleNumber(rcData?.rcNumber)
              ).toUpperCase()} TRANSPORT DEPARTMENT AUTHORITY - ${String(
                rcData?.registered_at
              ).toUpperCase()}`}</span>
            </span>
          </h1>
        </div>

        {/* Grid: header section */}
        <section className="mt-2 grid grid-cols-2 gap-0.5">
          <Row label="Registration No." value={safe(rcData?.rcNumber)} />
          <Row label="Date of Registration." value={dmy(rcData?.issue_date)} />

          <Row
            label="Dealer's Name & Address"
            value={safe(v?.dealer_name)}
            col
          />
          <Row label="Owner Name" value={safe(owner?.name)} />
          <Row label="Son/wife/daughter of" value={safe(owner?.father_name)} />
          <Row
            label="Full Address: (Permanent)"
            value={safe(owner?.permanent_address)}
            col
          />
          <Row
            label="Full Address: (Temporary)"
            value={safe(owner?.present_address)}
            col
          />
          <Row label="Nominee Name" value={safe("")} />
          <Row label="Relationship with the nominee" value={safe("")} />
          <Row label="Mobile No." value={safe("")} />
          <Row label="Old Registration No" value="" />
        </section>
        <table class="-ml-3 w-full border border-[#6aa6d8] text-[14px] text-center border-collapse mt-2">
          <thead>
            <tr class="text-center">
              <th class="border-2 border-[#6aa6d8] px-2 py-1">
                <span className="relative -top-2">S. No</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1">
                <span className="relative -top-2">Previous Owner Name</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1">
                <span className="relative -top-2">Address</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1">
                <span className="relative -top-2">Transfer Date</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[60px]">
                <span className="relative -top-2">1</span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[200px]">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[400px]">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px]">
                <span className="relative -top-2"></span>
              </td>
            </tr>
          </tbody>
        </table>
        {/* Vehicle details */}
        <div className="mt-1 grid grid-cols-2 gap-0.5">
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">RC Cancel Details:</span>
            </span>
          </div>
          <Row label="a) Date" value="" />
          <Row label="b) Cancel Reason" value="" />
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">Hypothecation Details:</span>
            </span>
          </div>
          <Row label="a) Financer Name" value={safe(rcData?.financier)} />
          <Row label="b) Financer Type" value={safe("")} />
          <Row label="c) Financer Address" value={safe("")} col />
          <Row
            label="The Motor Vehicle is."
            value={safe(rcData?.is_commercial ? "Transport" : "Non Transport")}
          />
          <Row label="Sale Amount" value={safe("")} />
          <Row label="Class of Vehicle" value={safe(v?.category_description)} />
          <Row
            label="Month and Year of Manufacture"
            value={safe(
              moment(new Date(v?.manufactured_date)).format("M/ YYYY")
            )}
          />
          <Row label="No. Of Cylinders" value={safe(v?.number_of_cylinders)} />
          <Row label="Norms" value={safe(rcData?.norms_type)} />
          <Row label="Chassis No" value={safe(v?.chassis_number)} />
          <Row label="Colour" value={safe(v?.color)} />
          <Row label="Engine No." value={safe(v?.engine_number)} />
          <Row label="Type Of body" value={safe(v?.body_type)} />
          <Row label="Maker's Name" value={safe(v?.maker_description)} />
          <Row label="Model Name" value={safe(v?.maker_model)} />

          <Row label="Fuel Used in Engine" value={safe(v?.fuel_type)} />
          <Row label="Horse Power(B.H.P)" value="" />
          <Row label="Cubic Capacity" value={safe(v?.cubic_capacity, "0")} />
          <Row label="Wheel Base" value={safe(v?.wheelbase, "0")} />
          <Row
            label="Seating Capacity"
            value={safe(v?.seating_capacity, "0")}
          />
          <Row
            label="Standing Capacity"
            value={safe(v?.standing_capacity, "0")}
          />
          <Row
            label="Sleeper Capacity"
            value={safe(v?.sleeper_capacity, "0")}
          />
          <Row label="Length" value="0" />
          <Row label="Width" value="0" />
          <Row label="Height" value="0" />
          <Row label="Laden Wt" value={safe(v?.laden_weight, "0")} />
          <Row label="Unladen Wt" value={safe(v?.unladen_weight, "0")} />
          <Row label="Gross Vehicle Wt" value={safe(v?.gross_weight, "0")} />
          <Row label="Owner Sr." value={safe(owner?.serial)} />
        </div>
        <div className="mt-2 grid :grid-cols-4 gap-0.5">
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">
                Number & Description of size of tyres :
              </span>
            </span>
          </div>
          <InlineRow label="a) Front:" value="" />
          <InlineRow label="b) Rear:" value="" />
          <InlineRow label="c) Other:" value="" />
          <InlineRow label="d) Tandem:" value="" />
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">
                Registered Axle Weight (In respect of each axle):
              </span>
            </span>
          </div>
          <InlineRow label="a) Front:" value="" />
          <InlineRow label="b) Rear:" value="" />
          <InlineRow label="c) Other:" value="" />
          <InlineRow label="d) Tandem:" value="" />
        </div>
        <div className="mt-2 grid grid-cols-2 gap-0.5">
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">Insurance Details :</span>
            </span>
          </div>
          <Row label="Purchase Date" value={safe(dmy(rcData?.issue_date))} />
          <Row label="Policy No." value={safe(ins?.policy_number)} />
          <Row label="INSURANCE TYPE" value="" />
          <Row label="Insurance Validity" value={safe(dmy(ins?.expiry_date))} />
          <Row label="INSURANCE COMPANY" value={safe(ins?.company)} col />
          <div className="-ml-3 col-span-2 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">Fee Details :</span>
            </span>
          </div>
          <Row label="Appl No." value="" />
          <Row label="Fee/Tax Receipt No." value="" />
        </div>
        <table class="w-full border border-[#6aa6d8] text-[14px] border-collapse mt-2">
          <thead>
            <tr class="text-left">
              <th class="border-2 border-[#6aa6d8] px-2 py-1">
                <span className="relative -top-2">Particular</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1 text-right">
                <span className="relative -top-2">Amount</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1 text-right">
                <span className="relative -top-2">Penalty</span>
              </th>
              <th class="border-2 border-[#6aa6d8] px-2 py-1 text-right">
                <span className="relative -top-2">Total</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[400px]">
                <span className="relative -top-2">Hypothecation Addition</span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
            </tr>
            <tr>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[400px]">
                <span className="relative -top-2">MV Tax (ONE TIME)</span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
              <td class="border border-[#6aa6d8] px-2 py-1 w-[120px] text-right">
                <span className="relative -top-2"></span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-start gap-[150px]">
          <div className="pr-2 text-[14px] font-bold">
            Registration valid upto
          </div>
          <div className="pr-2 text-[14px] font-bold">Fitness valid upto</div>
        </div>
        <div className="pr-2 text-[14px] font-bold">GRAND TOTAL (in Rs):</div>
        {/* Footer signatures */}
        <div className="mt-2 grid grid-cols-3 gap-0.5">
          <div className="col-span-3 text-[14px] font-semibold tracking-wide underline underline-offset-4">
            <span className="border-b border-black">
              <span className="relative -top-2">
                Name and Designation of the Inspecting Officer who certifies the
                vehicle as fit for registration:
              </span>
            </span>
          </div>
          <Row label="Inspector Name" value={""} col />
          <div />
          <div className="flex justify-between col-span-3">
            <div className="pr-2 text-[14px] font-bold">Owner Signature</div>
            <div className="pr-2 text-[14px] font-bold">
              Registering Authority
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/** Reusable row */
function Row({ label, value, col = false }) {
  return (
    <div className={`${col ? "col-span-2" : ""} grid grid-cols-[220px_1fr]`}>
      <div className="pr-2 text-[14px] font-bold">{label}</div>
      <div className="font-normal text-[14px]">
        : {String(value).toUpperCase()}
      </div>
    </div>
  );
}

function InlineRow({ label, value, col = false }) {
  return (
    <div className={`flex`}>
      <div className="pr-2 text-[14px] font-bold">{label}</div>
      <div className="font-normal text-[14px]">
        {String(value).toUpperCase()}
      </div>
    </div>
  );
}
